import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../reducers/hooks";
import {getAllElement} from "../../../reducers/Municipality/MunicipalityReducer";
import {Form, FormikProvider, useFormik} from "formik";
import * as Yup from "yup";
import {
    Autocomplete,
    Checkbox,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    TextField
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import {saveElement, TenantElement, updateElement} from "../../../reducers/Tenant/TenantReducer";
import {FormattedMessage, useIntl} from "react-intl";


export default function TenantElementForm({closeModal, element}: { closeModal: () => void, element: TenantElement }) {
    const dispatch = useAppDispatch();

    // Seleziona i dati dal Redux store
    const cities = useAppSelector((state) => state.municipalityElement.elements);
    const intl = useIntl()

    // Effettua il dispatch dell'azione per ottenere i dati dei municipi
    useEffect(() => {
        dispatch(getAllElement());
    }, [dispatch]);

    const formik = useFormik({
        initialValues: element ? element : {
            _id: '',
            businessName: '',
            city: '',
            isActive: false
        },
        validationSchema: Yup.object().shape({
            businessName: Yup.string()
                .min(2, intl.formatMessage({id: "Length not valid, min 2 characters"}))
                .required(intl.formatMessage({id: "The business name is required"})),

            city: Yup.string().required(intl.formatMessage({id: "The city is required"})),

            active: Yup.boolean()
        }),

        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                if (element && element._id) {
                    dispatch(updateElement(values))
                } else {
                    dispatch(saveElement(values))
                }
                closeModal();
            } catch (error) {
                console.error('Error:', error);
            }
        }
    });

    const selectedCity = cities.find(city => city.name === formik.values.city) || null


    if (element && element._id) {
        return (

            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                    <DialogTitle>{intl.formatMessage({id: "New Tenant"})}</DialogTitle>
                    <Divider/>
                    <DialogContent sx={{p: 2.5}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="businessName">
                                        <FormattedMessage id="businessName" defaultMessage="businessName"/>
                                    </InputLabel>
                                    <TextField
                                        fullWidth
                                        id="businessName"
                                        placeholder={intl.formatMessage({id: "Insert the business name"})}
                                        {...formik.getFieldProps('businessName')}
                                        error={Boolean(formik.touched.businessName && formik.errors.businessName)}
                                        helperText={formik.touched.businessName && formik.errors.businessName}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="city">
                                        <FormattedMessage id="city" defaultMessage="city"/>
                                    </InputLabel>
                                    <Autocomplete
                                        id="city"
                                        value={selectedCity || undefined}
                                        onChange={(e, newValue) => {
                                            formik.setFieldValue("city", newValue ? newValue.name : '');
                                        }}
                                        options={cities}
                                        getOptionLabel={(option) => option.name || option.name || ''}
                                        isOptionEqualToValue={(option, value) => value ? option.name === value.name : false}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={intl.formatMessage({id: "Select City"})}
                                                error={Boolean(formik.touched.city && formik.errors.city)}
                                                helperText={formik.touched.city && formik.errors.city}
                                            />
                                        )}
                                        disableClearable
                                        noOptionsText="No city found"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="element-isActive">
                                        <FormattedMessage id="Active" defaultMessage="Active"/></InputLabel>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                id="element-isActive"
                                                checked={formik.values.isActive}
                                                onChange={(e) => formik.setFieldValue('isActive', e.target.checked)}
                                                name="isActive"
                                                color="primary"
                                            />
                                        }
                                        label={intl.formatMessage({id: "Enabled"})}
                                    />
                                    {formik.touched.isActive && formik.errors.isActive && (
                                        <span style={{color: 'red'}}>{formik.errors.isActive}</span>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <Divider/>
                    <DialogActions sx={{p: 2.5}}>
                        <Grid container justifyContent="flex-end" alignItems="center">
                            <Grid item>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Button color="error" onClick={closeModal}>
                                        <FormattedMessage id="Cancel" defaultMessage="Cancel"/>
                                    </Button>
                                    <Button type="submit" variant="contained">
                                        <FormattedMessage id="Save" defaultMessage="Save"/>
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Form>
            </FormikProvider>
        );
    } else {
        return (

            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                    <DialogTitle>{intl.formatMessage({id: "New Tenant"})}</DialogTitle>
                    <Divider/>
                    <DialogContent sx={{p: 2.5}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="businessName">
                                        <FormattedMessage id="businessName" defaultMessage="businessName"/>
                                    </InputLabel>
                                    <TextField
                                        fullWidth
                                        id="businessName"
                                        placeholder={intl.formatMessage({id: "Insert the business name"})}
                                        {...formik.getFieldProps('businessName')}
                                        error={Boolean(formik.touched.businessName && formik.errors.businessName)}
                                        helperText={formik.touched.businessName && formik.errors.businessName}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="city">
                                        <FormattedMessage id="city" defaultMessage="city"/>
                                    </InputLabel>
                                    <Autocomplete
                                        id="city"
                                        value={selectedCity || undefined}
                                        onChange={(e, newValue) => {
                                            formik.setFieldValue("city", newValue ? newValue.name : '');
                                        }}
                                        options={cities}
                                        getOptionLabel={(option) => option.name || option.name || ''}
                                        isOptionEqualToValue={(option, value) => value ? option.name === value.name : false}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={intl.formatMessage({id: "Select City"})}
                                                error={Boolean(formik.touched.city && formik.errors.city)}
                                                helperText={formik.touched.city && formik.errors.city}
                                            />
                                        )}
                                        disableClearable
                                        noOptionsText="No city found"
                                    />
                                </Stack>
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                                <Stack spacing={1}>
                                    <InputLabel htmlFor="element-isActive">
                                        <FormattedMessage id="Active" defaultMessage="Active" /></InputLabel>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                id="element-isActive"
                                                checked={formik.values.isActive}
                                                onChange={(e) => formik.setFieldValue('isActive', e.target.checked)}
                                                name="isActive"
                                                color="primary"
                                            />
                                        }
                                        label={intl.formatMessage({id: "Enabled"})}
                                    />
                                    {formik.touched.isActive && formik.errors.isActive && (
                                        <span style={{ color: 'red' }}>{formik.errors.isActive}</span>
                                    )}
                                </Stack>
                            </Grid>*/}
                        </Grid>
                    </DialogContent>
                    <Divider/>
                    <DialogActions sx={{p: 2.5}}>
                        <Grid container justifyContent="flex-end" alignItems="center">
                            <Grid item>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Button color="error" onClick={closeModal}>
                                        <FormattedMessage id="Cancel" defaultMessage="Cancel"/>
                                    </Button>
                                    <Button type="submit" variant="contained">
                                        <FormattedMessage id="Save" defaultMessage="Save"/>
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Form>
            </FormikProvider>
        );
    }

}
